import { alpha } from '@mui/material';

export const PLATFORMS = [
    { label: 'Twitter', color: '#1DA1F2', bg: alpha('#1DA1F2', 0.1) },
    { label: 'Instagram', color: '#E1306C', bg: alpha('#E1306C', 0.1) },
    { label: 'LinkedIn', color: '#0A66C2', bg: alpha('#0A66C2', 0.1) },
    { label: 'Reddit', color: '#FF4500', bg: alpha('#FF4500', 0.1) },
    { label: 'YouTube', color: '#FF0000', bg: alpha('#FF0000', 0.1) },
];

export const FEATURE_CHIPS = [
    { label: 'Sentiment Analysis', color: '#10b981' },
    { label: 'Engagement Score', color: '#6366f1' },
    { label: 'Readability', color: '#8b5cf6' },
    { label: 'Keywords', color: '#06b6d4' },
    { label: 'Named Entities', color: '#f59e0b' },
    { label: 'AI Suggestions', color: '#ec4899' },
];

export const VIRALITY_COLORS = {
    High: { bg: alpha('#10b981', 0.12), text: '#10b981' },
    Medium: { bg: alpha('#f59e0b', 0.12), text: '#f59e0b' },
    Low: { bg: alpha('#ef4444', 0.12), text: '#ef4444' },
};
